import { useMemo, useState } from "react";
import { motion } from "framer-motion";
import ImmediateDigest from "./Widgets/ImmediateDigest";
import InboxPanel from "./Widgets/InboxPanel";
import NewDataPanel from "./Widgets/NewDataPanel";
import NewsAnchorWidget from "./Widgets/NewsAnchorWidget";

const getTheme = (dark) =>
  dark
    ? {
        cardBg: "rgba(15,23,42,0.60)",
        cardBorder: "rgba(14,165,233,0.12)",
        textPrimary: "rgba(226,232,240,0.9)",
        textSecondary: "rgba(148,163,184,0.7)",
        textMuted: "rgba(148,163,184,0.4)",
        activeText: "rgba(14,165,233,0.9)",
        activeBorder: "rgba(14,165,233,0.30)",
        activeBg: "rgba(14,165,233,0.15)",
        dangerText: "rgba(248,113,113,0.9)",
      }
    : {
        cardBg: "rgba(241,245,249,0.8)",
        cardBorder: "rgba(203,213,225,0.5)",
        textPrimary: "rgba(15,23,42,0.9)",
        textSecondary: "rgba(71,85,105,0.8)",
        textMuted: "rgba(148,163,184,0.6)",
        activeText: "rgba(2,132,199,1)",
        activeBorder: "rgba(14,165,233,0.30)",
        activeBg: "rgba(14,165,233,0.10)",
        dangerText: "rgba(220,38,38,0.9)",
      };

const panelVariants = {
  hidden: { opacity: 0, filter: "blur(6px)" },
  visible: (i) => ({
    opacity: 1,
    filter: "blur(0px)",
    transition: {
      duration: 0.4,
      delay: i * 0.1,
      ease: [0.25, 0.46, 0.45, 0.94],
    },
  }),
};

const OverviewView = ({ dark }) => {
  const t = useMemo(() => getTheme(dark), [dark]);
  const [hasVideos, setHasVideos] = useState(true);

  return (
    <div className="flex h-full w-full gap-3 p-4 font-poppins font-normal text-mainText">
      <motion.div
        className="min-w-0 flex-1"
        custom={0}
        initial="hidden"
        animate="visible"
        variants={panelVariants}
      >
        <div className="h-full overflow-hidden rounded-lg border border-surfaceBorder bg-surface/80 shadow-login-panel backdrop-blur-md">
          <ImmediateDigest dark={dark} t={t} />
        </div>
      </motion.div>

      {/* Right: News Anchor + Inbox + New Data (thirds) */}
      <div className="flex-1 min-w-0 flex flex-col gap-3">
        {hasVideos && (
          <motion.div
            className="flex-1 min-h-0"
            custom={1}
            initial="hidden"
            animate="visible"
            variants={panelVariants}
          >
            <div
              className="h-full rounded-lg overflow-hidden"
              style={{
                background: t.cardBg,
                border: `1px solid ${t.cardBorder}`,
              }}
            >
              <NewsAnchorWidget
                dark={dark}
                t={t}
                onEmpty={() => setHasVideos(false)}
              />
            </div>
          </motion.div>
        )}

        <motion.div
          className="flex-1 min-h-0"
          custom={2}
          initial="hidden"
          animate="visible"
          variants={panelVariants}
        >
          <div className="h-full overflow-hidden rounded-lg border border-surfaceBorder bg-surface/80 shadow-login-panel backdrop-blur-md">
            <InboxPanel dark={dark} t={t} />
          </div>
        </motion.div>

        <motion.div
          className="flex-1 min-h-0"
          custom={3}
          initial="hidden"
          animate="visible"
          variants={panelVariants}
        >
          <div className="h-full overflow-hidden rounded-lg border border-surfaceBorder bg-surface/80 shadow-login-panel backdrop-blur-md">
            <NewDataPanel dark={dark} t={t} />
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default OverviewView;
